
{
  "familyId": "GET-VERH-VERDELEN",
  "questions": [
    {
      "id": "GET-VERH-VERDELEN-001",
      "familyId": "GET-VERH-VERDELEN",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_verdelen",
      "questionType": "multiple_choice",
      "question": "Een notaris verdeelt een erfenis van €120 in de verhouding 2 : 3. Hoeveel krijgt het grootste deel?",
      "options": ["€72", "€80", "€60", "€48"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "barModel",
          "data": {
            "total": 120,
            "segments": 5,
            "highlighted": [0, 1, 2],
            "showUnknownMarker": true,
            "label": "€120 verdeeld in 5 gelijke delen — 3 voor het grootste deel, 2 voor het kleinste"
          },
          "a11y": { "alt": "Strookmodel: 5 gelijke delen, 3 gemarkeerd voor het grootste deel" }
        }
      ],
      "supportAids": [
        {
          "type": "barModel",
          "showWhen": "wrong",
          "data": {
            "total": 120,
            "segments": 5,
            "highlighted": [0, 1, 2],
            "showSegmentValues": true,
            "label": "Elk deel is €120 ÷ 5 = €24. Drie delen = 3 × €24 = €72."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen in verhouding",
            "content": "1. Tel de delen op (2 + 3 = 5). 2. Bereken 1 deel (totaal ÷ aantal delen). 3. Vermenigvuldig met het gewenste aantal delen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verh_verdelen_geld",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Bereken de waarde van 1 deel. Totaal delen: 2 + 3 = 5. 1 deel = €120 ÷ 5 = €24. Grootste deel (3 delen): 3 × €24 = €72.",
        "solutionSteps": [
          "Totaal delen: 2 + 3 = 5",
          "1 deel = €120 ÷ 5 = €24",
          "Grootste deel: 3 × €24 = €72"
        ],
        "distractorExplanations": {
          "0": "Goed! 120 ÷ 5 = 24 per deel. Grootste deel: 3 × 24 = €72.",
          "1": "Je dacht waarschijnlijk dat je door 3 deelt. Maar het totaal is 2 + 3 = 5 delen, niet 3. Onthoud: tel eerst alle delen op.",
          "2": "Je dacht waarschijnlijk dat je halveert. Maar de verhouding is 2:3, niet 1:1. Onthoud: 120 ÷ 2 = 60 zou kloppen bij gelijke verdeling.",
          "3": "Je dacht waarschijnlijk dat €48 het grootste deel is. Maar 2 × 24 = €48 is het kleinste deel (2 delen). Onthoud: het grootste deel heeft 3 delen: 3 × 24 = €72."
        }
      }
    },
    {
      "id": "GET-VERH-VERDELEN-002",
      "familyId": "GET-VERH-VERDELEN",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_verdelen",
      "questionType": "multiple_choice",
      "question": "Een sportcoördinator verdeelt 45 medailles over drie teams in de verhouding 1 : 2 : 6. Hoeveel krijgt het middelste team?",
      "options": ["10", "15", "5", "30"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "barModel",
          "data": {
            "total": 45,
            "segments": 9,
            "highlighted": [1, 2],
            "showUnknownMarker": true,
            "label": "45 medailles in 9 gelijke delen — 2 voor het middelste team (verhouding 1 : 2 : 6)"
          },
          "a11y": { "alt": "Strookmodel: 9 gelijke delen, 2 gemarkeerd voor het middelste team" }
        }
      ],
      "supportAids": [
        {
          "type": "barModel",
          "showWhen": "wrong",
          "data": {
            "total": 45,
            "segments": 9,
            "highlighted": [1, 2],
            "showSegmentValues": true,
            "label": "Elk deel = 45 ÷ 9 = 5. Middelste team (2 delen) = 2 × 5 = 10."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen over drie groepen",
            "content": "1. Tel alle delen op (1 + 2 + 6 = 9). 2. Bereken 1 deel (45 ÷ 9 = 5). 3. Vermenigvuldig met het gewenste aantal delen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verh_verdelen_drie",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Bereken 1 deel. Totaal delen: 1 + 2 + 6 = 9. 1 deel = 45 ÷ 9 = 5. Middelste team (2 delen): 2 × 5 = 10 medailles.",
        "solutionSteps": [
          "Totaal delen: 1 + 2 + 6 = 9",
          "1 deel = 45 ÷ 9 = 5",
          "Middelste team: 2 × 5 = 10"
        ],
        "distractorExplanations": {
          "0": "Goed! 45 ÷ 9 = 5 per deel. Middelste team: 2 × 5 = 10 medailles.",
          "1": "Je dacht waarschijnlijk dat je door 3 deelt. Maar de verhouding is 1:2:6, niet gelijk. Onthoud: 45 ÷ 3 = 15 zou kloppen bij gelijke verdeling.",
          "2": "Je dacht waarschijnlijk dat 5 het antwoord is. Maar 5 is het kleinste deel (1 × 5). Het middelste team heeft 2 delen: 2 × 5 = 10. Onthoud: lees goed welk deel gevraagd wordt.",
          "3": "Je dacht waarschijnlijk dat 30 het antwoord is. Maar 30 is het grootste deel (6 × 5). Het middelste team heeft 2 delen: 2 × 5 = 10. Onthoud: het middelste team = 2 delen."
        }
      }
    },
    {
      "id": "GET-VERH-VERDELEN-003",
      "familyId": "GET-VERH-VERDELEN",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_verdelen",
      "questionType": "multiple_choice",
      "question": "Een aannemer mengt zand en cement in de verhouding 4 : 1. Hij heeft 25 kg nodig. Hoeveel kg zand gebruikt hij?",
      "options": ["20 kg", "24 kg", "5 kg", "100 kg"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "barModel",
          "data": {
            "total": 25,
            "segments": 5,
            "highlighted": [0, 1, 2, 3],
            "showUnknownMarker": true,
            "label": "25 kg in 5 gelijke delen — 4 voor zand, 1 voor cement (verhouding 4 : 1)"
          },
          "a11y": { "alt": "Strookmodel: 5 gelijke delen, 4 gemarkeerd voor zand" }
        }
      ],
      "supportAids": [
        {
          "type": "barModel",
          "showWhen": "wrong",
          "data": {
            "total": 25,
            "segments": 5,
            "highlighted": [0, 1, 2, 3],
            "showSegmentValues": true,
            "label": "Elk deel = 25 ÷ 5 = 5 kg. Zand (4 delen) = 4 × 5 = 20 kg."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Mengverhouding berekenen",
            "content": "1. Tel de delen op (4 + 1 = 5). 2. Bereken 1 deel (25 ÷ 5 = 5 kg). 3. Zand = 4 delen = 4 × 5 = 20 kg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verh_verdelen_materiaal",
      "variantIndex": 3,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Bereken 1 deel van het totaal. Totaal delen: 4 + 1 = 5. 1 deel = 25 ÷ 5 = 5 kg. Zand (4 delen): 4 × 5 = 20 kg.",
        "solutionSteps": [
          "Totaal delen: 4 + 1 = 5",
          "1 deel = 25 ÷ 5 = 5 kg",
          "Zand: 4 × 5 = 20 kg"
        ],
        "distractorExplanations": {
          "0": "Goed! 25 ÷ 5 = 5 per deel. Zand: 4 × 5 = 20 kg.",
          "1": "Je dacht waarschijnlijk dat je 25 − 1 = 24 rekent. Maar cement is 1 deel van 5, niet 1 kg. Onthoud: 1 deel = 25 ÷ 5 = 5 kg, cement = 5 kg.",
          "2": "Je dacht waarschijnlijk dat 5 kg het antwoord is. Maar 5 kg is het cement-deel (1 × 5). Zand heeft 4 delen: 4 × 5 = 20 kg. Onthoud: lees goed welk materiaal gevraagd wordt.",
          "3": "Je dacht waarschijnlijk dat je 25 × 4 rekent. Maar je vermenigvuldigt het deel (5 kg) met 4, niet het totaal. Onthoud: 1 deel = 25 ÷ 5 = 5 kg, zand = 4 × 5 = 20 kg."
        }
      }
    },
    {
      "id": "GET-VERH-VERDELEN-004",
      "familyId": "GET-VERH-VERDELEN",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_verdelen",
      "questionType": "multiple_choice",
      "question": "Een schooldirecteur verdeelt 30 leerlingen over twee groepen in de verhouding jongens : meisjes = 3 : 2. Hoeveel meisjes zijn er?",
      "options": ["12", "18", "15", "20"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "barModel",
          "data": {
            "total": 30,
            "segments": 5,
            "highlighted": [3, 4],
            "showUnknownMarker": true,
            "label": "30 leerlingen in 5 gelijke delen — 3 jongens, 2 meisjes"
          },
          "a11y": { "alt": "Strookmodel: 5 gelijke delen, 2 gemarkeerd voor meisjes" }
        }
      ],
      "supportAids": [
        {
          "type": "barModel",
          "showWhen": "wrong",
          "data": {
            "total": 30,
            "segments": 5,
            "highlighted": [3, 4],
            "showSegmentValues": true,
            "label": "Elk deel = 30 ÷ 5 = 6. Meisjes (2 delen) = 2 × 6 = 12."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen in verhouding",
            "content": "1. Tel de delen op (3 + 2 = 5). 2. Bereken 1 deel (30 ÷ 5 = 6). 3. Meisjes = 2 delen = 2 × 6 = 12.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verh_verdelen_personen",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Bereken 1 deel. Totaal delen: 3 + 2 = 5. 1 deel = 30 ÷ 5 = 6. Meisjes (2 delen): 2 × 6 = 12.",
        "solutionSteps": [
          "Totaal delen: 3 + 2 = 5",
          "1 deel = 30 ÷ 5 = 6",
          "Meisjes: 2 × 6 = 12"
        ],
        "distractorExplanations": {
          "0": "Goed! 30 ÷ 5 = 6 per deel. Meisjes: 2 × 6 = 12.",
          "1": "Je dacht waarschijnlijk dat 18 het aantal meisjes is. Maar 3 × 6 = 18 is het aantal jongens, niet meisjes. Onthoud: meisjes = 2 delen, jongens = 3 delen.",
          "2": "Je dacht waarschijnlijk dat je halveert. Maar de verhouding is 3:2, niet 1:1. Onthoud: 30 ÷ 2 = 15 zou kloppen bij gelijke verdeling.",
          "3": "Je dacht waarschijnlijk dat je door de verhouding deelt. Maar 30 ÷ 3 × 2 = 20 is niet correct. Onthoud: tel eerst alle delen op: 3 + 2 = 5, dan 30 ÷ 5 = 6."
        }
      }
    },
    {
      "id": "GET-VERH-VERDELEN-005",
      "familyId": "GET-VERH-VERDELEN",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_verdelen",
      "questionType": "ratio_table",
      "question": "Een kok verdeelt 600 gram deeg over twee broden in de verhouding 1 : 2. Hoeveel gram krijgt het grote brood?",
      "options": ["400 gram", "300 gram", "200 gram", "500 gram"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Brood", "Verhouding", "Gewicht (gram)"],
        "rows": [
          ["Klein", 1, null],
          ["Groot", 2, null]
        ],
        "hiddenCells": [
          { "row": 0, "col": 2 },
          { "row": 1, "col": 2 }
        ],
        "missingCell": { "row": 1, "col": 2 },
        "correctValue": 400
      },
      "stimulusAids": [
        {
          "type": "barModel",
          "data": {
            "total": 600,
            "segments": 3,
            "highlighted": [1, 2],
            "showUnknownMarker": true,
            "label": "600 gram in 3 gelijke delen — 2 voor het grote brood, 1 voor het kleine"
          },
          "a11y": { "alt": "Strookmodel: 3 gelijke delen, 2 gemarkeerd voor het grote brood" }
        }
      ],
      "supportAids": [
        {
          "type": "barModel",
          "showWhen": "wrong",
          "data": {
            "total": 600,
            "segments": 3,
            "highlighted": [1, 2],
            "showSegmentValues": true,
            "label": "Elk deel = 600 ÷ 3 = 200 gram. Groot brood (2 delen) = 2 × 200 = 400 gram."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen in verhouding",
            "content": "1. Tel de delen op (1 + 2 = 3). 2. Bereken 1 deel (600 ÷ 3 = 200 gram). 3. Groot brood = 2 delen = 2 × 200 = 400 gram.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verh_verdelen_deeg",
      "variantIndex": 5,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Totaal delen: 1 + 2 = 3. 1 deel = 600 ÷ 3 = 200 gram. Groot brood (2 delen): 2 × 200 = 400 gram. Controleer: 200 + 400 = 600 ✓.",
        "solutionSteps": [
          "Totaal delen: 1 + 2 = 3",
          "1 deel = 600 ÷ 3 = 200 gram",
          "Groot brood: 2 × 200 = 400 gram",
          "Controleer: 200 + 400 = 600 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 600 ÷ 3 = 200 per deel. Groot brood: 2 × 200 = 400 gram.",
          "1": "Je dacht waarschijnlijk dat je halveert. Maar de verhouding is 1:2, niet 1:1. Onthoud: 600 ÷ 2 = 300 zou kloppen bij gelijke verdeling.",
          "2": "200 gram is het kleine brood (1 deel). Het grote brood heeft 2 delen: 2 × 200 = 400 gram.",
          "3": "Je dacht waarschijnlijk dat de verhouding 1:5 is. Maar de verhouding is 1:2, totaal 3 delen. 1 deel = 200 gram, groot = 400 gram."
        }
      }
    },
    {
      "id": "GET-VERH-VERDELEN-006",
      "familyId": "GET-VERH-VERDELEN",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_verdelen",
      "questionType": "ratio_table",
      "question": "Een tuinman verdeelt 80 bloembollen over twee perken in de verhouding 3 : 5. Hoeveel bollen komen in het grootste perk?",
      "options": ["50", "30", "48", "40"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Perk", "Verhouding", "Bollen"],
        "rows": [
          ["Perk A", 3, null],
          ["Perk B", 5, null]
        ],
        "hiddenCells": [
          { "row": 0, "col": 2 },
          { "row": 1, "col": 2 }
        ],
        "missingCell": { "row": 1, "col": 2 },
        "correctValue": 50
      },
      "stimulusAids": [
        {
          "type": "barModel",
          "data": {
            "total": 80,
            "segments": 8,
            "highlighted": [3, 4, 5, 6, 7],
            "showUnknownMarker": true,
            "label": "80 bollen in 8 gelijke delen — 5 voor het grootste perk, 3 voor het kleinere"
          },
          "a11y": { "alt": "Strookmodel: 8 gelijke delen, 5 gemarkeerd voor het grootste perk" }
        }
      ],
      "supportAids": [
        {
          "type": "barModel",
          "showWhen": "wrong",
          "data": {
            "total": 80,
            "segments": 8,
            "highlighted": [3, 4, 5, 6, 7],
            "showSegmentValues": true,
            "label": "Elk deel = 80 ÷ 8 = 10 bollen. Grootste perk (5 delen) = 5 × 10 = 50."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen in verhouding",
            "content": "1. Tel de delen op (3 + 5 = 8). 2. Bereken 1 deel (80 ÷ 8 = 10). 3. Grootste perk = 5 delen = 5 × 10 = 50 bollen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verh_verdelen_bollen",
      "variantIndex": 6,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Totaal delen: 3 + 5 = 8. 1 deel = 80 ÷ 8 = 10 bollen. Grootste perk (5 delen): 5 × 10 = 50 bollen. Controleer: 30 + 50 = 80 ✓.",
        "solutionSteps": [
          "Totaal delen: 3 + 5 = 8",
          "1 deel = 80 ÷ 8 = 10 bollen",
          "Grootste perk: 5 × 10 = 50 bollen",
          "Controleer: 30 + 50 = 80 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 80 ÷ 8 = 10 per deel. Grootste perk: 5 × 10 = 50 bollen.",
          "1": "30 is het kleinste perk (3 × 10). Het grootste perk heeft 5 delen: 5 × 10 = 50.",
          "2": "Je dacht waarschijnlijk dat de verhouding 2:3 is. Maar de verhouding is 3:5, totaal 8 delen. 1 deel = 10, groot = 50.",
          "3": "Je dacht waarschijnlijk dat je halveert. Maar de verhouding is 3:5, niet 1:1. Onthoud: 80 ÷ 2 = 40 zou kloppen bij gelijke verdeling."
        }
      }
    },
    {
      "id": "GET-VERH-VERDELEN-007",
      "familyId": "GET-VERH-VERDELEN",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verhoudingen",
      "subSkill": "verh_verdelen",
      "questionType": "bar_model_part",
      "question": "Een bouwer verdeelt 60 stenen over twee muren in de verhouding 3 : 2. Hoeveel stenen krijgt de grootste muur? Lees af op het strookmodel.",
      "options": [],
      "correctAnswer": 36,
      "data": {
        "barModelPart": {
          "total": 60,
          "segments": 5,
          "highlighted": [0, 1, 2],
          "promptLabel": "Hoeveel stenen krijgt de grootste muur (3 delen van 5)?"
        }
      },
      "stimulusAids": [
        {
          "type": "barModel",
          "data": {
            "total": 60,
            "segments": 5,
            "highlighted": [0, 1, 2],
            "showUnknownMarker": true,
            "label": "60 stenen verdeeld in 5 gelijke delen — 3 voor de grote muur, 2 voor de kleine"
          }
        }
      ],
      "supportAids": [
        {
          "type": "barModel",
          "showWhen": "wrong",
          "data": {
            "total": 60,
            "segments": 5,
            "highlighted": [0, 1, 2],
            "showSegmentValues": true,
            "label": "Elk deel is 60 ÷ 5 = 12 stenen. Drie delen = 3 × 12 = 36."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Strookmodel bij verhoudingen",
            "content": "Tel alle delen op (3 + 2 = 5). Verdeel het totaal: 60 ÷ 5 = 12 per deel. De grootste muur krijgt 3 delen: 3 × 12 = 36 stenen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verh_verdelen_strookmodel",
      "variantIndex": 7,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het strookmodel verdeelt 60 stenen in 5 gelijke delen. Elk deel is 60 ÷ 5 = 12 stenen. De grootste muur krijgt 3 delen: 3 × 12 = 36 stenen. Controleer: 36 + 24 = 60 ✓.",
        "solutionSteps": [
          "Totaal delen: 3 + 2 = 5",
          "1 deel = 60 ÷ 5 = 12 stenen",
          "Grootste muur: 3 × 12 = 36 stenen",
          "Controleer: 36 + 24 = 60 ✓"
        ]
      },
      "pedagogy": { "dok": 2 }
    }
  ]
}
